import { siteConst } from "../constants/siteConst";
import { siteService } from "../../services/API/siteService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";
import 'whatwg-fetch';

export const siteActions = {
  getCountry,
  get_site_details,
  update_site,
  getDashobardData,
  checkSiteStatus,
  getCustomerData,
  formSetting,
  saveBecomeForm,
  getLookupData,
  getSiteStatus,
  getApiSetting,
  saveApiSetting,
  installssl,
  updateAccountSettings
};

function getLookupData(formData, lookupType){
  return dispatch => {
    siteService.getLookupData(formData, lookupType).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_LOOKUP_DATA_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_LOOKUP_DATA_SUCCESS, lookupType:lookupType, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_LOOKUP_DATA_FAILURE, error };
  }
};

function getCustomerData(formData){
  return dispatch => {
    siteService.getCustomerData(formData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_CUSTOMER_DATA_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_CUSTOMER_DATA_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_CUSTOMER_DATA_FAILURE, error };
  }
};

function getDashobardData(formData){
  return dispatch => {
    siteService.getDashobardData(formData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_DASHBOARD_DETAILS_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_DASHBOARD_DETAILS_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_DASHBOARD_DETAILS_FAILURE, error };
  }
};

function getCountry() {
  return dispatch => {
    dispatch(request());

    siteService.getCountry().then(
      user => {
        dispatch(success(user));
        alert("user");
      },
      error => {
        dispatch(failure(error.toString()));
        alert("No");
      }
    );
  };

  function request() {
    return { type: siteConst.GETCOUNTRY_REQUEST };
  }
  function success(users) {
    return { type: siteConst.SITE_GETCOUNTRY_SUCCESS, users };
  }
  function failure(error) {
    return { type: siteConst.SITE_GETCOUNTRY_FAILURE, error };
  }
}

export const get_site_details = (siteID) => {
  return dispatch => {
    siteService.get_site_details(siteID).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_SITE_DETAILS_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_SITE_DETAILS_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_SITE_DETAILS_FAILURE, error };
  }
};

export const formSetting = postData => {
  return dispatch => {
    siteService.formSetting(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_FORMSETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_FORMSETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_FORMSETTING_FAILURE, error };
  }
}
export const saveBecomeForm = (postData, url) => {
  return dispatch => {
    siteService.saveBecomeForm(postData, url).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.POST_FORMSETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_FORMSETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_FORMSETTING_FAILURE, error };
  }
}
export const update_site = postData => {
  return dispatch => {
    siteService.update_site(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.UPDATE_SITE_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.UPDATE_SITE_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.UPDATE_SITE_FAILURE, error };
  }
};


function checkSiteStatus(postData){
  return dispatch => {
    siteService.checkSiteStatus(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.CHECK_SITE_STATUS_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.CHECK_SITE_STATUS_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.CHECK_SITE_STATUS_FAILURE, error };
  }
};

export const getSiteStatus = postData => {
  return dispatch => {
    siteService.checkSiteStatus(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.CHECK_SITE_STATUS_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.CHECK_SITE_STATUS_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.CHECK_SITE_STATUS_FAILURE, error };
  }
};




export const getApiSetting = postData => {
  return dispatch => {
    siteService.getApiSetting(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_APISETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_APISETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_APISETTING_FAILURE, error };
  }
};

export const saveApiSetting = postData => { 
  return dispatch => {
    siteService.saveApiSetting(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.POST_APISETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_APISETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_APISETTING_FAILURE, error };
  }
};

export const getSeoSetting = postData => {
  return dispatch => {
    siteService.getSeoSetting(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_APISETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_APISETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_APISETTING_FAILURE, error };
  }
};

export const saveSeoSetting = postData => {
  return dispatch => {
    siteService.saveSeoSetting(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.POST_APISETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_APISETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_APISETTING_FAILURE, error };
  }
};

export const getAddRole = postData => {
  return dispatch => {
    siteService.getAddRole(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.GET_APISETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.GET_APISETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.GET_APISETTING_FAILURE, error };
  }
};

export const saveAddRole = (postData, url) => {
  return dispatch => {
    siteService.saveAddRole(postData, url).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.POST_APISETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_APISETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_APISETTING_FAILURE, error };
  }
};

export const roleList = postData => {
  return dispatch => {
    siteService.roleList(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.POST_ROLELIST_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_ROLELIST_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_ROLELIST_FAILURE, error };
  }
};

export const roleStatus = postData => {
  return dispatch => {
    siteService.roleStatus(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.POST_ROLESTATUS_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_ROLESTATUS_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_ROLESTATUS_FAILURE, error };
  }
};

export const installssl = postData => {
  return dispatch => {
    siteService.installssl(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConst.POST_SSL_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_SSL_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_SSL_FAILURE, error };
  }
};

export const updateAccountSettings = postData => {
  return dispatch => {
    siteService.updateAccountSettings(postData).then(
      responseData => {
        dispatch(success(responseData));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    )
  };


  function request(responseData) {
    return { type: siteConst.POST_ACCOUNT_SETTING_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConst.POST_ACCOUNT_SETTING_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConst.POST_ACCOUNT_SETTING_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/siteActions.js